/* eslint-disable import/prefer-default-export */
import creator from './creator';
// import storage from '../core/storage';

import {
  SET_BIND_STATUS,
  SET_BACK_URL,
  LOG_IN,
  // USERS_BY_MOBILE,
  // SET_TOAST_MSG,
  FETCH_LOGIN_INFO,
} from '../constants';

// 设置绑定时的状态数据
export const setBindStatusEnd = creator(SET_BIND_STATUS, 'data')
export function setBindStatus(data) {
  return function setBindStatusAction(dispatch) {
    dispatch(setBindStatusEnd(data))
  }
}

// 检测虚拟号
export function virtualMobileTest(phoneNumber) {
  return async function virtualMobileTestAction(dispatch, getState, { ds }) {
    try {
      const resp = await ds.virtualMobileTest(phoneNumber)
      const data = await resp.json()
      return data
    } catch (error) {
      console.error('手机号检测异常,请确认手机号输入无误', error) // eslint-disable-line no-console
      // eslint-disable-next-line consistent-return
      return {}
    }
  }
}

/*
  登录类型存储到localstorage,主要用于验证是否为手机号登录
  {
    1:手机号登录
    2:邮箱登录
    4:第三方登录
  }
*/
// export function setMoStatus(num) {
//   return function setMoStatusAction() {
//     storage.save({
//       mo: num,
//     });
//   };
// }

/*
  登录状态存储到localstorage,主要用于第三方登录成功后的操作
  needbind,是否需要绑定.{0:不需要,1:需要（此时处于手机号已登录，绑定主账号未登录的状态,此状态下的登录页面不显示手机号登录组件）}
  thirdlogin,是否为第三方（微博、微信、qq）登录后的callback页面.{0:否,2:是}
  lostatus = needbind + thirdlogin.
  {
    0:非第三方登录后的callback页,不需要绑定
    1:非第三方登录后的callback页,需要绑定
    2:第三方登录后的callback页,不需要绑定
    3:第三方登录后的callback页,需要绑定
  }
*/
// export function setLoStatus(num) {
//   return function setLoStatusAction() {
//     storage.save({
//       lostatus: num,
//     })
//   }
// }

// 获取登录前的url地址
export const setBackUrlStatus = creator(SET_BACK_URL, 'backurl')
export function setBackUrl(url = location.host) {
  return function setBackUrlAction(dispatch) {
    dispatch(setBackUrlStatus(url))
  }
}

// 手机号登录
export const logInEnd = creator(LOG_IN, 'data')
export function logIn(cf, tp = 'urs-phone-web') {
  return async function loginAction(dispatch, getState, { ds }) {
    try { // 默认cf=7
      // const cf = checked ? 7 : 3
      const resp = await ds.login(cf, tp)
      const data = await resp.json()
      // dispatch(logInEnd(data))
      return data
    } catch (error) {
      console.error('手机号登录异常，请稍后再试', error) // eslint-disable-line no-console
      return {}
    }
  }
}

// 查找使用过该手机号的用户信息（账号类型，昵称，头像）
// export const fetchUserInfoByMbEnd = creator(USERS_BY_MOBILE, 'data')
// export function fetchUserInfoByMb(mobile) {
//   return async function fetchUIBMAction(dispatch, getState, { ds }) {
//     try {
//       const resp = await ds.userinfoByMobile(mobile)
//       const data = await resp.json()
//       dispatch(fetchUserInfoByMbEnd(data))
//     } catch (error) {
//       console.log('查找使用过该手机号的用户信息异常，请稍后再试', error) // eslint-disable-line no-console
//     }
//   }
// }

// 设置toast信息
// export const setToastMsgEnd = creator(SET_TOAST_MSG, 'data')
// export function setToastMsg(data) {
//   return function setToastMsgAction(dispatch) {
//     dispatch(setToastMsgEnd(data))
//   }
// }

// 查询登录信息 http://luna.corp.youdao.com/index.php?title=AccountServer/co/cq
export const fetchLoginInfoEnd = creator(FETCH_LOGIN_INFO, 'data');
export function fetchLoginInfo() {
  return async function fetchLoginInfoAction(dispatch, getState, { ds }) {
    try {
      const resp = await ds.fetchLoginInfo();
      const data = await resp.json();
      if (data.code === 0) {
        dispatch(fetchLoginInfoEnd(data.data))
      }
    } catch (error) {
      console.error('查找用户信息异常，请稍后再试', error); // eslint-disable-line no-console
    }
  };
}

export function containCourse() {
  return async function fetchContainCourse(dispatch, getState, { ds }) {
    try {
      const resp = await ds.containCourse()
      const data = await resp.json();
      if (data.code === 0) {
        return data.data
      }

      console.error('containCourse:', data.msg)
      return false
    } catch (err) {
      console.error('containCourse', err) // eslint-disable-line no-console
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/login.js